// extracted by mini-css-extract-plugin
export default {"certificate":"Certificates_certificate__8CGgX"};